import { Text } from "@meditect/medibase-components";

export const SalesCannotEditClosedSaleError = () => {
  return <Text>Cette vente a déjà été clôturée.</Text>;
};
